export { default } from '@/shared/components/Footer';
